import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { injectIntl } from 'react-intl';

// Components
import CustomerVehicle from './CustomerVehicle';

// Actions
import {
  setCustomerVehicle,
  setEmail,
  setPhoneNumber,
  setMobilePhoneNumber,
  setObfuscatedBy,
  setFirstName,
  setLastName
} from 'store/reducers/appointment/actions';
import { getDeclinedServices } from 'store/reducers/declined/actions';
import { setLoginData } from 'store/reducers/login/actions';
import { gtmUserEvent } from 'store/reducers/gtm/actions';

// Selectors
import {
  getDealerCountryCode,
  getShowMileage
} from 'store/reducers/dealerSettings/selectors';
import { getDeclinedServicesPromotion as getDeclinedServicesFromStore } from 'store/reducers/declined/selectors';
import { getDeferredServices as getDeferredServicesFromStore } from 'store/reducers/deferred/selectors';
import { getSearchCriteriaFindMe } from 'store/reducers/userInteractions/selectors';

// Utils
import { undefinedToTrue } from 'utils/varValidation';

const mapStateToProps = (state, { showMileage }) => ({
  dealerCountryCode: getDealerCountryCode(state),
  declinedServices: getDeclinedServicesFromStore(state),
  deferredServices: getDeferredServicesFromStore(state),
  searchCriteriaFindMe: getSearchCriteriaFindMe(state),
  showMileage: showMileage || undefinedToTrue(getShowMileage(state))
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setEmail,
      setPhoneNumber,
      setMobilePhoneNumber,
      setCustomerVehicle,
      getDeclinedServices,
      setLoginData,
      gtmUserEvent,
      setObfuscatedBy,
      setFirstName,
      setLastName
    },
    dispatch
  );

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(CustomerVehicle);



// WEBPACK FOOTER //
// ./src/components/atoms/CustomerVehicle/CustomerVehicleContainer.js